import { css } from '@emotion/react'
 /** @jsxImportSource @emotion/react */
import React,{ useEffect, useState} from 'react'
import { useLocation } from 'react-router-dom';

import { Form, Input, Select  } from 'antd';
import {ButtonBase} from '@mui/material';

import axios from '../apiClient';
import Alert from '../alert';
import Loader from '../loader';


export default function EditSubOwner() {
  const [loading,setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState({});
  const [openAlert, setOpenAlert] = useState(false);
  const [accessTypes,setAccessTypes] = useState([]);
  const location = useLocation();
  // console.log(location.state)
  const {id: ownerId} = location.state;
  
  const onFinish = async (values) => {
    let {phNum: phoneNumber,password,access} = values;
    const accessString = access.join(',');
    setLoading(true)

    if(!password) password = "";
    const params ={ownerId,phoneNumber,password,accessType: accessString}
    const data = await axios.put(`/owner/editSubOwner`,params)

    setErrorMsg({ code: data.code, msg: data.message })
    setLoading(false)
    setOpenAlert(true)
  };

  const getAccessTypes = async() => {
    const res = await axios.get(`/owner/getAccessTypesList`);
    if(res.code == 200) {
      let arr = [...res.data,{access_types: '*',display_name: 'All'}]
      setAccessTypes(arr)
    }
  }

  useEffect(()=>{
     getAccessTypes();
  },[])

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const handleCloseAlert =()=>{
    setOpenAlert(false)
  }
  return (
    <div
      css={css`
        /* background-color: #ffffff; */
        border-radius: 1rem;
        margin: 0 10rem;
        padding: 1rem;
      `}
    >
        {/* <h2 style={{fontWeight: 'normal',marginBottom: "2rem"}}>Edit User</h2> */}
      <Alert openAlert={openAlert} errorMsg={errorMsg} handleCloseAlert={handleCloseAlert}/>
      <Form
        name="basic"
        className="create-user"
        style={{
          fontFamily: "inherit",
        }}
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Upper accessTypes={accessTypes} />
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            padding: "0 2rem",
            marginTop: "2rem",
          }}
        >
          <ButtonBase
            type="submit"
            component="button"
            style={{
              color: "white",
              display: "flex",
              backgroundColor: "#5e35b1",
              padding: "0.6rem 1.8rem",
              borderRadius: "2rem",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
             {loading ? <Loader btn creatUser/>: <h4 style={{ textAlign: "center", margin: 0 }}>Edit</h4>}
          </ButtonBase>
        </div>
      </Form>
    </div>
  );
}

const Upper = ({accessTypes}) =>{
  const location = useLocation();
  const {name,phone_number,access_type} = location.state;
  const arrAccessType = access_type.split(",");
  const validatePassword = (_, value) => {
    if (value && !/(?=.*[A-Z])(?=.*\d).{8,}/.test(value)) {
      return Promise.reject(
        'Password must contain at least one capital letter, one number, and be at least 8 characters long'
      );
    }
    return Promise.resolve();
  };
  return (
    <div
    css={css`
    /* background-color: #EEEEEE; */
    padding: 1rem;
    border-radius: 1rem;
    margin-top: 1rem;
    box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
    -moz-box-shadow: -2px 2px 12px -3px rgba(0, 0, 0, 0.3);
  `}
    >
      <div
        css={css`
          display: flex;
        `}
      >
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Username"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="name"
          style={{ padding: "0 0.4rem", color: "white" }}
          initialValue={name}
        >
          <Input
            css={css`
              :hover {
                border-color: red;
              }
            `}
            size="large"
            disabled
          />
        </Form.Item>
        <Form.Item
          css={css`
            flex-basis: 50%;
          `}
          label="Phone Number"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="phNum"
          style={{ padding: "0 0.4rem", color: "white" }}
          initialValue={phone_number}
        >
          <Input  size="large" />
        </Form.Item>
        
      </div>
      {/* <div
        css={css`
          display: flex;
        `}
      > */}
        <Form.Item
          // css={css`
          //   flex-basis: 50%;
          // `}
          label="Password"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          name="password"
          hasFeedback
          style={{ padding: "0 0.4rem", color: "white" }}
          rules={[
            {
              validator: validatePassword
            },
          ]}
        >
          <Input.Password
            css={css`
              :hover {
                border-color: red;
              }
            `}
            size="large"
          />
        </Form.Item>
       
      {/* </div> */}
      <Form.Item
            css={css`
            `}
            label="Access"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            name="access"
            hasFeedback
            initialValue={arrAccessType}
            rules={[
              {
                required: true,
                message: `Please select access!`,
              }
            ]}
            style={{ padding: "0 0.4rem", color: "white" }}
          >
            <Select
              mode="multiple"
              size="large"
              placeholder="Please select Access"
              // onChange={handleCreateCardOptionChange}
              options={accessTypes.map(v=> {
                return {value: v.access_types,label: v.display_name}
              })}
            />
      </Form.Item>
    </div>
  );
}